<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE INGRESO ACOMODACION -->
              <v-card flat v-if="tabSelected == 'Ingreso Acomodaciones'">
                <grid-acomodaciones
                  :key="gridDocumento"
                  :rowsTable="rowsTable"
                  :contratoId="contratoId"
                ></grid-acomodaciones>
              </v-card>
              <!-- TAB DE RESUMEN DE ACOMODACIONES -->
              <v-card flat v-if="tabSelected == 'Resumen Acomodación'">
                <resumen-acomodaciones
                  :key="gridDocumento2"
                  :rowsTable="rowsTable"
                  :contratoId="contratoId"
                ></resumen-acomodaciones>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import GridAcomodaciones from "@/modules/aplicacion/views/acomodacion/GridAcomodaciones.vue";
import ResumenAcomodaciones from "@/modules/aplicacion/views/acomodacion/ResumenAcomodaciones.vue";

export default {
  name: "acomodaciones-tab",

  components: {
    Loading,
    GridAcomodaciones,
    ResumenAcomodaciones,
  },

  props: {
    //tabSelected: ""
  },

  data() {
    return {
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      index: "",
      tabs: ["Ingreso Acomodaciones", "Resumen Acomodación"],
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
      gridDocumento2: 20,
      activeTab: "",
      index: "",
      active_tab: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;

    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
      //this.gridDocumento2 += 22;
    },
    loadSelected() {
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },
    selected(tab) {
      this.$store.commit("sub_tab_state", tab);
      this.tabSelected = tab;
    },
  },
};
</script>
